import { render, staticRenderFns } from "./ProjectPhase.vue?vue&type=template&id=8fa3720a&"
import script from "./ProjectPhase.vue?vue&type=script&lang=ts&"
export * from "./ProjectPhase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports